/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Leveling_Managed_DriftedInputs */



/**
* | output |
* | --- |
* | "changed in Discord: {fields}" |
*
* @param {Leveling_Managed_DriftedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_managed_drifted = /** @type {((inputs: Leveling_Managed_DriftedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Managed_DriftedInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`изменено в Discord: ${i?.fields}`)
	return /** @type {LocalizedString} */ (`changed in Discord: ${i?.fields}`)
});